import { useEffect } from 'react';
import { usePageMetadata } from '../context/PageMetadataContext';

/**
 * Hook for pages to register their last updated metadata.
 * Call this at the top of your page component with the page's PAGE_LAST_UPDATED export.
 *
 * @param {Object|null} pageLastUpdated - { dateTime: string, displayDate: string } or null
 */
export const usePageLastUpdated = (pageLastUpdated) => {
  const { setMetadata } = usePageMetadata();

  useEffect(() => {
    setMetadata(pageLastUpdated || null);
    return () => setMetadata(null);
  }, [pageLastUpdated, setMetadata]);
};
